import { PageRef } from 'providers/page-ref';

export type AdminEditTextPageParams = {
  id?: string;
};

export const IAdminEditTextPage: PageRef<AdminEditTextPageParams, void> = {
  pageName: 'AdminEditTextPage',
} as PageRef<AdminEditTextPageParams, void>;
